export default __webpack_public_path__ + "308075f4758a7363d7aedcf1ab68a34a.svg";